import { useResourcePermission } from "src/components/permission/use-resource-permission";
import { useSpaceContext } from "src/components/spaces";
import { useLifecycleStudioEnabled } from "src/hooks/use-lifecycle-studio-enabled";
import { useIsAdStudioEnabled } from "src/pages/agents/hooks/use-is-ad-studio-enabled";

export const AD_STUDIO_TEMPLATES_PATH = "/ad-studio/templates";
export const EMAIL_TEMPLATES_PATH = "/lifecycle-studio/templates";

export const useTemplateLibraryAccess = () => {
  const isAdStudioEnabled = useIsAdStudioEnabled();
  const isLifecycleStudioEnabled = useLifecycleStudioEnabled();
  const { isPermitted: canViewAgents } = useResourcePermission({
    v2: { resource: "workspace", grant: "can_view_agents" },
  });
  const { isInSpace, isPathOrChildrenAccessibleInSpace } = useSpaceContext();
  const canAccess = (path: string) =>
    canViewAgents && (!isInSpace || isPathOrChildrenAccessibleInSpace(path));
  const showAdTemplates =
    isAdStudioEnabled && canAccess(AD_STUDIO_TEMPLATES_PATH);
  const showEmailTemplates =
    isLifecycleStudioEnabled && canAccess(EMAIL_TEMPLATES_PATH);
  const paths = [
    ...(showAdTemplates ? [AD_STUDIO_TEMPLATES_PATH] : []),
    ...(showEmailTemplates ? [EMAIL_TEMPLATES_PATH] : []),
  ];

  return {
    showAdTemplates,
    showEmailTemplates,
    paths,
    homePath: paths[0] ?? null,
  };
};
